import UserFeedback, { CreateUserFeedback, UserFeedbackCSV } from "types/user-feedback";
import { getJson, postJson } from "./request";

export const createUserFeedback = (userFeedbackInfo: CreateUserFeedback): Promise<UserFeedback> =>
  postJson(`/user-feedback`, userFeedbackInfo);

export const getFeedbackCSV = (): Promise<UserFeedbackCSV> => getJson(`/user-feedback/csv`);
